import { CoursesApiError } from "./types";

export interface RawResponse {
  status: number;
  ok: boolean;
  body: unknown;
}

/**
 * Faz um `fetch` e devolve status + corpo já parseado. Diferente de
 * `src/http.ts::request` (que só retorna boolean), aqui precisamos do status e
 * do corpo para distinguir resultado de negócio de falha real.
 *
 * Lê o corpo como texto e tenta `JSON.parse` — alguns erros voltam como texto
 * puro (ex.: `403 "forbidden 0"`). Erro de rede vira `CoursesApiError(status: 0)`.
 */
export async function fetchJson(
  url: string,
  init?: RequestInit,
): Promise<RawResponse> {
  let res: Response;
  try {
    res = await fetch(url, init);
  } catch (err) {
    throw new CoursesApiError(
      `Falha de rede ao chamar ${url}.`,
      0,
      err,
    );
  }

  const text = await res.text();
  let body: unknown;
  try {
    body = text.length > 0 ? JSON.parse(text) : undefined;
  } catch {
    body = text;
  }

  return { status: res.status, ok: res.ok, body };
}
